export default __webpack_public_path__ + "static/about-intro-triangle1.url-eabef0cd8a669879a22456b76eb98a41.svg";